import {
    PermissionModules,
    PermissionTypes,
} from "@callveriq/config/permissions.config";
import { RouteType } from "@callveriq/config/routes.config";
import { Role } from "@callveriq/type/Role";
import { AuthUserType } from "@callveriq/type/User";
import { createContext } from "react";

export type CheckCanAccessParams = {
    heading: PermissionModules;
    code_name?: string;
    permission_type?: PermissionTypes;
};
export interface IAuthContextState {
    user: AuthUserType | null | undefined;
    isAuthenticated: boolean;
    isInitialized: boolean;
    isInternalUser: boolean;
}

export interface IAuthContextInterface extends IAuthContextState {
    handleLogin: (
        credentials:
            | {
                  email: string;
                  password: string;
                  rawEmail: string;
              }
            | { params: { [k: string]: string } }
    ) => Promise<void>;
    handleLogout: () => Promise<void>;
    initialize: () => Promise<void>;
    isAuditor: boolean;
    checkIsOwner: (id: number | undefined | null) => boolean;
    checkCanAccess: (
        { heading, code_name, permission_type }: CheckCanAccessParams,
        role?: Role
    ) => boolean;
    isLoginRequestInProgress: boolean;
    isLogoutRequestInProgress: boolean;
    isAuthenticateRequestInProgress: boolean;
    checkDashboardVisibility: (e: RouteType) => boolean;
    handleVerifyOtp: (email: string, otp: string) => Promise<void>;
    isVerifyOtpRequestInProgress: boolean;
    updateUser: (user: AuthUserType) => void;
    canAssignSessions: boolean;
}

const AuthContext = createContext<IAuthContextInterface | null>(null);

export default AuthContext;
